import { useEffect } from 'react';

/**
 * Custom hook that adds scroll event listeners to close popovers/dropdowns
 * when scrolling occurs, preventing them from floating away from their triggers.
 *
 * @param scrollContainerRef - Ref to the specific scroll container element
 * @param handleScroll - Callback function to execute on scroll events
 */
export function useScrollListener(
  scrollContainerRef: React.RefObject<HTMLElement>,
  handleScroll: () => void
) {
  const scrollContainer = scrollContainerRef.current;

  useEffect(() => {
    // Add listener to the specific scroll container
    scrollContainer?.addEventListener('scroll', handleScroll, {
      passive: true,
    });

    return () => {
      scrollContainer?.removeEventListener('scroll', handleScroll);
    };
  }, [scrollContainer, handleScroll]);
}
